import { c as _c } from "react/compiler-runtime";
import { ArrowUpRight } from "lucide-react";
import Image from "next/image";
import { TransitionLink } from "@/components/transition-link";
import type { HomeProject } from "@/lib/projects";
import Bg_Waves from "~/public/assets/backgrounds/bg-waves.png";
function isLightColor(hex: string): boolean {
  const clean = hex.replace("#", "");
  const r = parseInt(clean.substring(0, 2), 16);
  const g = parseInt(clean.substring(2, 4), 16);
  const b = parseInt(clean.substring(4, 6), 16);
  const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
  return luminance > 180;
}
type CaseCardProps = {
  project: HomeProject;
  tag?: string;
};
export function CaseCard(t0) {
  const $ = _c(29);
  const {
    project,
    tag
  } = t0;
  const previewImage = project.preview ?? project.image;
  let t1;
  if ($[0] !== project.colors.primary) {
    t1 = isLightColor(project.colors.primary);
    $[0] = project.colors.primary;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const lightBg = t1;
  const t2 = `Ver case ${project.name}`;
  const t3 = `case-card group relative block overflow-hidden rounded-2xl transform-3d
				${tag ? "min-h-122" : "min-h-112"}`;
  const t4 = `/portfolio/${project.slug}`;
  let t5;
  if ($[2] !== project.colors.primary) {
    t5 = {
      backgroundColor: project.colors.primary
    };
    $[2] = project.colors.primary;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Image src={Bg_Waves} alt="" aria-hidden="true" className="case-card-waves pointer-events-none absolute top-0 left-0 right-0 z-0 mix-blend-screen w-full opacity-80" priority={false} width={1920} height={1080} />;
    t7 = <ArrowUpRight aria-hidden="true" className="case-card-arrow pointer-events-none absolute top-8 right-8 z-20 size-10 text-white opacity-0" strokeWidth={1.4} />;
    $[4] = t6;
    $[5] = t7;
  } else {
    t6 = $[4];
    t7 = $[5];
  }
  let t8;
  if ($[6] !== lightBg || $[7] !== tag) {
    t8 = tag ? <span className={`mb-3 inline-flex rounded-lg px-2.5 py-1.5 text-[11px] font-medium uppercase tracking-[0.01em] ${lightBg ? "bg-gray-900/10 text-gray-900" : "bg-white/15 text-white"}`}>{tag}</span> : null;
    $[6] = lightBg;
    $[7] = tag;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const t9 = `text-3xl font-bold font-bricolage ${lightBg ? "text-gray-900" : "text-white"}`;
  let t10;
  if ($[9] !== project.name || $[10] !== t9) {
    t10 = <h3 className={t9}>{project.name}</h3>;
    $[9] = project.name;
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  const t11 = `case-card-excerpt line-clamp-2 font-manrope ${lightBg ? "text-gray-700" : "text-white"}`;
  const t12 = project.description ?? project.excerpt ?? "Projeto digital desenvolvido pela Flow.";
  let t13;
  if ($[12] !== t11 || $[13] !== t12) {
    t13 = <p className={t11}>{t12}</p>;
    $[12] = t11;
    $[13] = t12;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] !== t10 || $[16] !== t13 || $[17] !== t8) {
    t14 = <div className="case-card-body relative z-10 flex h-full flex-col px-10 pt-14"><div className="case-card-content pointer-events-none">{t8}{t10}{t13}</div></div>;
    $[15] = t10;
    $[16] = t13;
    $[17] = t8;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  const t15 = previewImage.alternativeText ?? project.name;
  let t16;
  if ($[19] !== previewImage.url || $[20] !== t15) {
    t16 = <div className="case-card-media pointer-events-none absolute -bottom-14"><Image src={previewImage.url} alt={t15} className="case-card-image h-full w-full min-h-84 object-cover" priority={false} width={2000} height={2000} /></div>;
    $[19] = previewImage.url;
    $[20] = t15;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] !== t14 || $[23] !== t16 || $[24] !== t2 || $[25] !== t3 || $[26] !== t4 || $[27] !== t5) {
    t17 = <TransitionLink aria-label={t2} className={t3} href={t4} style={t5}>{t6}{t7}{t14}{t16}</TransitionLink>;
    $[22] = t14;
    $[23] = t16;
    $[24] = t2;
    $[25] = t3;
    $[26] = t4;
    $[27] = t5;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  return t17;
}